import css from 'styled-jsx/css';

export default css`:global(em) {
  color: white; }

h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.42;
  letter-spacing: 0.4px;
  text-align: center;
  color: #414141;
  margin-bottom: 64px;
  position: relative;
  margin-top: 160px; }

h2:after {
  content: '';
  display: block;
  width: 48px;
  height: 8px;
  background-color: #414141;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translateX(-50%); }

@media only screen and (max-width: 500px) {
  .success {
    margin-top: 40px; } }

@media only screen and (max-width: 500px) {
  .success h2 {
    margin-top: 0; } }

.success .box-wrap {
  display: flex;
  max-width: 1080px;
  margin: auto; }
  @media only screen and (max-width: 500px) {
    .success .box-wrap {
      width: 95%;
      flex-wrap: wrap; } }
  .success .box-wrap h2 {
    text-align: center; }
  .success .box-wrap .box {
    margin: 10px auto;
    text-align: center;
    position: relative; }
    @media only screen and (max-width: 500px) {
      .success .box-wrap .box {
        width: 45vw; } }
    .success .box-wrap .box .img img {
      width: 240px;
      height: 333px; }
      @media only screen and (max-width: 500px) {
        .success .box-wrap .box .img img {
          width: 95%;
          height: auto;
          margin: auto; } }
    .success .box-wrap .box .text {
      position: absolute;
      top: 205px;
      left: 50%;
      transform: translateX(-50%); }
      @media only screen and (max-width: 500px) {
        .success .box-wrap .box .text {
          top: unset;
          bottom: 28px; } }
      .success .box-wrap .box .text p {
        color: white;
        font-size: 16px;
        margin: 5px auto 10px;
        width: 137px;
        text-align: center; }
        @media only screen and (max-width: 500px) {
          .success .box-wrap .box .text p {
            font-size: 12px;
            width: 130px; } }
      .success .box-wrap .box .text .number {
        font-size: 32px;
        width: 171px;
        position: relative; }
        @media only screen and (max-width: 500px) {
          .success .box-wrap .box .text .number {
            font-size: 20px;
            width: auto; } }
        .success .box-wrap .box .text .number em {
          font-size: 12px;
          position: absolute;
          top: 0; }
      .success .box-wrap .box .text img {
        width: 16px;
        height: 16px;
        position: absolute;
        margin-top: 5px;
        top: 0;
        right: 0;
        cursor: pointer;
        animation: flicker 0.5s infinite; }
        @media only screen and (max-width: 500px) {
          .success .box-wrap .box .text img {
            margin-top: 3px; } }
        .success .box-wrap .box .text img :hover {
          opacity: 0.5;
          animation: none; }

@keyframes flicker {
  0% {
    opacity: 0.5; }
  50% {
    opacity: 1; }
  100% {
    opacity: 0.5; } }
`